import { Component, ViewEncapsulation, Input, OnInit, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';

import { QualityIssue, STATUS_TR } from '../../../../claim/models/quality-issue';
import { CURRENCY_OPTIONS } from '../../../models/list';
import { UNDERSCORE } from '../../../utils/constant';
import { NumberPipe } from '../../../pipes/number.pipe';
import { DatePipe } from '../../../pipes/date.pipe';

interface ClaimDisplayed {
	id: string;
	reference: string;
	status: string;
	amount?: number | undefined;
	currency?: string | undefined;
	creationDate: string;
	modicationDate: string;
}

@Component({
	selector: 'copo-result-claim-card',
	templateUrl: './result-card-claim.component.html',
	styleUrl: './result-card-claim.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		MatRippleModule,
		RouterLink,
		TranslateModule,
		DatePipe,
		NumberPipe,
	],
})
export class ResultCardClaimComponent implements OnInit {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() claim!: QualityIssue;
	claimDisplayed!: ClaimDisplayed;

	readonly UNDERSCORE = UNDERSCORE;

	ngOnInit() {
		const { claim } = this;
		this.claimDisplayed = {
			id: claim.id,
			reference: claim.customerReference,
			status: claim.status !== undefined ? STATUS_TR[claim.status] : STATUS_TR['claimstatus.unknowntype'],
			amount: claim.amountRequested,
			currency: claim.currencyRequested,
			creationDate: claim.creationDate,
			modicationDate: claim.modificationDate
		};
	}

	getUnitAmount(amountUnitTr?: string) {
		return amountUnitTr
			? CURRENCY_OPTIONS[<keyof typeof CURRENCY_OPTIONS> amountUnitTr.toLowerCase()]
			: CURRENCY_OPTIONS.eur;
	}
}
